import { PaginationQueryObject, QueryConfig } from "./Queries";

export const userWithRoleAssignments = (
  userId: string,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getUserWithRoleAssignments($userId: ID, $pagination: PaginationInput) {
        user(id: $userId) {
            id, 
            roleAssignments(paginationInput: $pagination) { 
                items {
                    id, role { id, name },
                }
            }
        }
    }`;
  return {
    query: query,
    variables: {
      userId: userId,
      pagination: pagination,
    },
  };
};

export const availableRolesListQuery = (
  customerId: string,
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getAvailableRoles($customerId: ID, $filter: RoleFilter, $pagination: PaginationInput) {
        customer(id: $customerId) {
          roles(filter: $filter, paginationInput: $pagination) {
            items { id, name, description },
            pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
          }
        }
    }`;
  return {
    query: query,
    variables: {
      customerId,
      filter,
      pagination,
    },
  };
};

export const userAssignedRolesListQuery = (
  userId: string,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getUsersAvailableRoles($userId: ID, $pagination: PaginationInput) {
        user(id: $userId) {
            roleAssignments(paginationInput: $pagination) {
                items {
                    id
                    locationId,
                    role {
                        id
                        name
                        description
                    },
                    location {
                        id
                        lineage
                        name
                    }
                },
                pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }
    }`;
  return {
    query: query,
    variables: {
      userId,
      pagination,
    },
  };
};

export type UserRoleAssignmentObject = {
  roleId: string;
  userId: string;
  customerId: string;
  locationIds: string[];
};

export const grantUserRoleAssignmentsMutation = (
  userRoleAssignments: UserRoleAssignmentObject[]
) => {
  const query = `mutation grantUserRoleAssignments($userRoleAssignments: [GrantRoleToUserInput]!) {
        grantRoleAssignments(inputs: $userRoleAssignments)
    }`;
  return {
    query: query,
    variables: {
      userRoleAssignments: userRoleAssignments,
    },
  };
};

export const revokeUserRoleAssignmentsMutation = (
  userRoleAssignments: UserRoleAssignmentObject[]
) => {
  const query = `mutation revokeUserRoleAssignments($userRoleAssignments: [RevokeRoleAssignmentInput]!) {
        revokeRoleAssignments(inputs: $userRoleAssignments)
    }`;
  return {
    query: query,
    variables: {
      userRoleAssignments: userRoleAssignments,
    },
  };
};
